import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  H2Styled,
  OrderNowWrapper
} from './GalleryPage.style';
import {OrderNow} from '../HomePage/HomePage.style';
import Promotions from '../../components/Promotions/Promotions';

const GalleryPromotions = ({
    orderNowButtonText,
    promotions
  }) => {
  const renderPromotions = Promotions({
    promotions,
    page: 'gallery'
  });

  return (
    <div>
      <H2Styled data-rw="gallery-page--deals">
        <FormattedMessage id="gallery.deals" />
      </H2Styled>
      {renderPromotions}
      <OrderNowWrapper>
        <OrderNow
          to="/menu"
          data-rw="home-page--order-now-link"
        >
          <FormattedMessage id={orderNowButtonText} />
        </OrderNow>
      </OrderNowWrapper>
    </div>
  );
};

GalleryPromotions.propTypes = {
  orderNowButtonText: PropTypes.string.isRequired,
  promotions: PropTypes.object.isRequired
};

export default GalleryPromotions;




// WEBPACK FOOTER //
// ./containers/GalleryPage/GalleryPromotions.js